import store from '@/store';
import ShippingTypes from '@/models/ShippingTypes';

export default {
    productHasShipping(){
        let shippingType = store.getters['shippingType/getType'];

        return shippingType != ShippingTypes.UNDEFINED && 
               shippingType != ShippingTypes.WITHOUT_SHIPPING_PICKUP && 
               shippingType != ShippingTypes.WITHOUT_SHIPPING &&
               store.getters['recurrentPayment/isRecurringPayment'] == false;
    }
};